<template>
  <div class="overflow" style="padding: 30px;height: 100%;overflow:auto;">
    <div class="settingDiv">
      <div style="color: rgb(7, 230, 248); ">
        系统视觉设置
        <a type="text" size="mini" @touchstart="updateSystemParamter('system_vision')" @click="updateSystemParamter('system_vision')"
           style="color:#299FFB; cursor: pointer; float: right;">
          编辑
        </a>
      </div>
      <el-row style="margin-left: 1%; margin-top: 2%;">
        <el-col :lg="3" :md="4" :sm="5" :xl="2" :xs="11">平台简称：</el-col>
        <el-col :xl="20" :lg="18" :md="18" :sm="18" :xs="13">{{ platform_abbreviation.val1 }}</el-col>
      </el-row>
      <el-row style="margin-left: 1%; margin-top: 2%;">
        <el-col :lg="3" :md="4" :sm="5" :xl="2" :xs="11">平台全称：</el-col>
        <el-col :xl="20" :lg="18" :md="18" :sm="18" :xs="13">{{platform_full_name.val1}}</el-col>
      </el-row>
      <el-row style="margin-left: 1%; margin-top: 2%;">
        <el-col :lg="3" :md="4" :sm="5" :xl="2" :xs="11">PC端logo：</el-col>
        <el-col :xl="20" :lg="18" :md="18" :sm="18" :xs="13">
          <img v-if="PC_terminal_logo.icon1 != 'null' && PC_terminal_logo.icon1 != ''"
               style="width: 100px; height: 100px;" :src="$ftpUrl + PC_terminal_logo.icon1"/>
          <div v-else> -</div>
        </el-col>
      </el-row>
      <el-row style="margin-left: 1%; margin-top: 2%; ">
        <el-col :lg="3" :md="4" :sm="5" :xl="2" :xs="11">移动端logo：</el-col>
        <el-col :xl="20" :lg="18" :md="18" :sm="18" :xs="13">
          <img v-if="mobile_terminal_logo.icon1 != 'null' && mobile_terminal_logo.icon1 != ''"
               style="width: 100px; height: 100px;" :src="$ftpUrl + mobile_terminal_logo.icon1"/>
          <div v-else> -</div>
        </el-col>
      </el-row>
    </div>

    <div class="settingDiv margin-top-20">
      <!--      <div style="color: rgb(7, 230, 248); font-size: 1.2rem; font-weight: bold;">-->
      <div style="color: rgb(7, 230, 248);">
        历史数据设置
        <a type="text" size="mini" @touchstart="updateSystemParamter('historical_data')" @click="updateSystemParamter('historical_data')"
           style="color:#299FFB; cursor: pointer; float: right;">
          编辑
        </a>
      </div>
      <el-row style="margin-left: 1%; margin-top: 2%;">
        <el-col :lg="3" :md="4" :sm="5" :xl="2" :xs="11">删除历史数据：</el-col>
        <el-col v-if="delete_historical_data.val1 == 'false'" :lg="18" :md="18" :sm="18" :xl="20" :xs="24">
          <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8"
                  style=" margin-top: 5px !important; width: 12px; height: 12px; border-radius: 50%; background: rgb(244,96,108);"></el-col>
          <el-col :xl="8" :lg="15" :md="15" :sm="15" :xs="15" style="margin-left: 2%;">已禁用，平台不会删除任何测点数据</el-col>
        </el-col>
        <el-col v-else :lg="18" :md="18" :sm="18" :xl="20" :xs="24">
          <el-col :lg="8" :md="8" :sm="8" :xl="8" :xs="2"
                  style=" margin-top: 5px !important; width: 12px; height: 12px; border-radius: 50%; background: rgb(88,224,57);"></el-col>
          <el-col :lg="15" :md="15" :sm="15" :xl="8" :xs="22" style="margin-left: 2%;">
            已启用，平台将删除{{ delete_historical_data.val2 == null ? 0 : delete_historical_data.val2 }}个月前的测点数据
          </el-col>
        </el-col>
      </el-row>

      <el-row style="margin-left: 1%; margin-top: 2%;" v-if="delete_historical_data.val1 == 'true'">
        <el-col :lg="3" :md="4" :sm="5" :xl="3" :xs="14">历史数据保留时长：</el-col>
        <el-col :lg="18" :md="18" :sm="18" :xl="20" :xs="10">
          <div>{{ delete_historical_data.val2 == null ? 0 : delete_historical_data.val2 }}&nbsp;个月</div>
        </el-col>
      </el-row>
    </div>


    <div class="settingDiv margin-top-20">
      <div style="color: rgb(7, 230, 248);">
        安全设置
        <a type="text" size="mini" @touchstart="updateSystemParamter('security_setting')" @click="updateSystemParamter('security_setting')"
           style="color:#299FFB; cursor: pointer; float: right;">
          编辑
        </a>
      </div>
      <el-row style="margin-left: 1%; margin-top: 2%;">
        <el-col :lg="3" :md="4" :sm="5" :xl="3" :xs="14">强制更新密码时长：</el-col>
        <el-col :lg="18" :md="18" :sm="18" :xl="20" :xs="10">
          {{ forced_password_update_duration.val1 == null ? 0 : forced_password_update_duration.val1 }}个月
        </el-col>
      </el-row>

    </div>

    <div class="settingDiv margin-top-20">
      <div style="color: rgb(7, 230, 248);">
        备份数据库
        <el-button style="color:#299FFB; cursor: pointer; float: right;margin-left: 2em" @touchstart="backUpDatabase" @click="openDialog" :loading="isBacking">备份历史和还原</el-button>
        <el-button style="color:#299FFB; cursor: pointer; float: right;" @touchstart="backUpDatabase" @click="backUpDatabase">备份数据库</el-button>
      </div>
    </div>

    <!--    弹出窗-->
    <function-dialog-component
        :dialog-title="title"
        :dialogVisible.sync="systemParamteDialogVisible"
        @dialogClose="(data) => this.systemParamteDialogVisible = data"
        center
        :closeClick="false"
        width="35vw">
      <div slot="content" :style="systemParamteDialogStyle">
        <edit-system-vision v-if="systemVision"
                            :platformAbbreviationData="edit_platform_abbreviation"
                            :platformFullNameData="edit_platform_full_name"
                            :PCTerminalLogoData="edit_PC_terminal_logo"
                            :mobileTerminalLogoData="edit_mobile_terminal_logo"
        />

          <edit-historical-data v-if="historicalData"
                                :deleteHistoricalData="deleteHistoricalData"
                                :editDeleteHistoricalData="edit_delete_historical_data"/>
        <edit-security-setting v-if="securitySetting"
                               :editForcedPasswordUpdateDuration="edit_forced_password_update_duration"/>
      </div>

      <div class="dialog-footer" slot="footer" style="text-align: center; margin-top: 40px; margin-bottom: 15px;">
        <el-button @touchstart="() => {this.systemParamteDialogVisible = false;}" @click="() => {this.systemParamteDialogVisible = false;}" size="mini">关 闭</el-button>
        <el-button @touchstart="commitSystematic" @click="commitSystematic" size="mini" type="primary">保 存</el-button>
      </div>
    </function-dialog-component>

    <dialog-component
      dialog-title="备份历史和还原"
      :closeClick="false"
      :dialogVisible.sync="dialogVisible"
      width="65vw"
      @dialogClose="(data) => this.dialogVisible = data">
      <div slot="content" style="height:70vh;padding: 20px 30px">
        <el-table
          :data="tableData"
          :height="'55vh'"
          class="table"
          style="width: 100%;margin-top: 10px;">
          <el-table-column
            align="center"
            label="名称"
            prop="name">
          </el-table-column>
          <el-table-column
            align="center"
            label="时间"
            prop="createTime">
          </el-table-column>
          <el-table-column
            align="center"
            label="状态"
            prop="status">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 0">
                <i class="el-icon-loading"
                   style="font-size: 1.2rem;margin-right: 5px;font-weight: bolder;"></i>
                正在加载中</span>
              <span v-if="scope.row.status === 2">
                <i class="el-icon-close"
                   style="font-size: 1.2rem;margin-right: 5px;font-weight: bolder;color: red;margin-top:3px;"></i>
                导出失败</span>
              <span v-if="scope.row.status === 1" style="color: #58E039">
                <i class="el-icon-check"
                   style="font-size: 1.2rem;margin-right: 5px;font-weight: bolder;">
                </i> 加载完成
              </span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="操作">
<!--            <template>-->
            <template slot-scope="scope" v-if="scope.row.sysType === 'backUpDatabase'">
<!--              <i class="el-icon-download text-blue pointer"-->
<!--                 @click="exportExcel(scope.row.fileUrl)"-->
<!--                 v-if="scope.row.status === 1"-->
<!--                 style="margin-right: 10px;font-size: 1.3rem;">-->
<!--              </i>-->
<!--              <i class="el-icon-download text-grey"-->
<!--                 v-else-->
<!--                 style="margin-right: 10px;font-size: 1.3rem;cursor: not-allowed">-->
<!--              </i>-->

<!--              <i class="el-icon-delete text-red pointer"-->
<!--                 @click="deleteInfoById(scope.row.id)"-->
<!--                 style="font-size: 1.2rem"></i>-->

              <el-button v-if="scope.row.status === 1" @touchstart="restoringDatabase(scope.row.id)" @click="restoringDatabase(scope.row.fileUrl)" :loading="isRestoring">还原</el-button>
              <el-button v-else disabled>还原</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row style="margin-top: 15px;text-align: center;" v-if="tableData.length">
          <el-pagination
            :current-page.sync="form.pageCurrent"
            :page-size="form.pageSize"
            :total="dataTotal"
            @current-change="handleCurrentChange"
            background
            layout="prev, pager, next">
          </el-pagination>
        </el-row>
      </div>
    </dialog-component>
  </div>
</template>

<script>

import {
  backUpDatabase,
  getSystematicByParentCodes,
  preservationAndQuerySystematic,
  saveOrUpdateSystematic,
  restoringDatabase
} from '@/network/systematic'
import FunctionDialogComponent from "@/components/FunctionDialogComponent";
import editSystemVision from "@/views/basic_operations/sys_setting/system_parameter/editSystemVision";
import editHistoricalData from "@/views/basic_operations/sys_setting/system_parameter/editHistoricalData";
import editSecuritySetting from "@/views/basic_operations/sys_setting/system_parameter/editSecuritySetting";
import DialogComponent from "@/components/DialogComponent";
import {getDatabasesList} from "@/network/ext-download-record";

export default {
  name: "SystemParamter",
  components: {FunctionDialogComponent, editSystemVision, editHistoricalData, editSecuritySetting,DialogComponent},
  inject: ['overflow'],
  data() {
    return {
      systemParamterData: [], //系统配置数据

      //显示数据
      PC_terminal_logo: {}, //PC端logo
      delete_historical_data: {}, // 删除历史数据
      mobile_terminal_logo: {},  //移动端logo
      platform_abbreviation: {}, //平台简称
      platform_full_name: {},  //平台全称

      //编辑数据
      edit_PC_terminal_logo: {}, //PC端logo
      edit_mobile_terminal_logo: {},  //移动端logo
      edit_platform_abbreviation: {}, //平台简称
      edit_platform_full_name: {},  //平台全称
      edit_delete_historical_data: {}, // 删除历史数据

      //安全设置
      forced_password_update_duration: {}, //强制更新密码时长
      edit_forced_password_update_duration: {},

      deleteHistoricalData: {
        val: false,
        time: 0,
      },

      extSystematic: {
        parentId: 0,
        code: "",
        name: "",
        val1: "",
        val2: "",
        ordinal: "",
        isDisplay: true,
        icon1: "",
        icon2: "",
        note: "",
        spare: "",
        manageable: true
      },

      //弹出窗
      title: '', //标题
      type: '',
      systemParamteDialogVisible: false, //弹出窗状态
      systemVision: false,  //系统视觉设置状态
      historicalData: false, //历史数据设置数据状态
      securitySetting: false, //安全设置状态
      dialogVisible: false,
      tableData: [],
      form: {
        pageCurrent: 1,
        pageSize: 10,
      },
      dataTotal: 0,
      isBacking: false,
      isRestoring: false
    }
  },
  //初始化数据
  mounted() {
    this.overflow()
    this.getSystemParamter();
  },
  //初始化参数
  computed: {},
  //后台交互方法
  methods: {
    getSystemParamter: function () {
      let codes = ["system_vision", "historical_data", "security_setting"];
      getSystematicByParentCodes(codes).then(res => {
        this.systemParamterData = res.data;
        console.log("系统配置参数：", this.systemParamterData);
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].code === "platform_abbreviation") {
            this.platform_abbreviation = res.data[i];
          } else if (res.data[i].code == 'platform_full_name') {
            this.platform_full_name = res.data[i];
          } else if (res.data[i].code == 'PC_terminal_logo') {
            this.PC_terminal_logo = res.data[i];
          } else if (res.data[i].code == 'mobile_terminal_logo') {
            this.mobile_terminal_logo = res.data[i];
          } else if (res.data[i].code == 'delete_historical_data') {
            this.delete_historical_data = res.data[i];
          } else if (res.data[i].code == 'forced_password_update_duration') {
            this.forced_password_update_duration = res.data[i];
          }
        }
      })
    },

    //编辑
    updateSystemParamter(row){
      this.systemVision = false;
      this.historicalData = false;
      this.securitySetting = false;

      if (row == 'system_vision') {
        this.title = '编辑系统视觉设置';
        this.type = "system_vision";
        this.systemVision = true;
        this.historicalData = false;
        this.securitySetting = false;

        this.edit_platform_abbreviation = JSON.parse(JSON.stringify(this.platform_abbreviation));
        this.edit_platform_full_name = JSON.parse(JSON.stringify(this.platform_full_name));
        this.edit_PC_terminal_logo = JSON.parse(JSON.stringify(this.PC_terminal_logo));
        this.edit_mobile_terminal_logo = JSON.parse(JSON.stringify(this.mobile_terminal_logo));

      }else if (row == 'historical_data'){
        this.title = '编辑历史数据设置';
        this.type = "historical_data";
        this.systemVision = false;
        this.historicalData = true;
        this.securitySetting = false;

        this.edit_delete_historical_data = JSON.parse(JSON.stringify(this.delete_historical_data));
        if (this.edit_delete_historical_data.val1 == "true"){
          this.deleteHistoricalData.val = true;
        }else{
          this.deleteHistoricalData.val = false;
        }
        this.deleteHistoricalData.time = this.edit_delete_historical_data.val2;
      }else if(row == 'security_setting'){
        this.title = '编辑安全设置';
        this.type = "security_setting";
        this.systemVision = false;
        this.historicalData = false;
        this.securitySetting = true;
        this.edit_forced_password_update_duration = JSON.parse(JSON.stringify(this.forced_password_update_duration));
      }
      this.systemParamteDialogVisible = true;
    },

    //保存
    commitSystematic(){
      //保存父配置
      if (this.type == "system_vision"){
        this.extSystematic.code = "system_vision";
        this.extSystematic.name = "系统视觉设置";
        preservationAndQuerySystematic(this.extSystematic.parentId,this.extSystematic.code,this.extSystematic.name,this.extSystematic.val1,this.extSystematic.val2,
            this.extSystematic.icon1,this.extSystematic.icon2).then(res => {
          console.log("保存系统配置返回参数：", res);
          if (res.code == 0) {
            this.edit_platform_abbreviation.parentId = res.data.id;
            this.edit_platform_full_name.parentId = res.data.id;
            this.edit_PC_terminal_logo.parentId = res.data.id;
            this.edit_mobile_terminal_logo.parentId = res.data.id;
            this.commitSon();
          }
        })
      }else if (this.type == "historical_data"){
        this.extSystematic.code = "historical_data";
        this.extSystematic.name = "历史数据设置";
        preservationAndQuerySystematic(this.extSystematic.parentId,this.extSystematic.code,this.extSystematic.name,this.extSystematic.val1,this.extSystematic.val2,
            this.extSystematic.icon1,this.extSystematic.icon).then(res => {
          console.log("保存系统父配置返回参数：", res);
          if (res.code == 0) {
            this.edit_delete_historical_data.parentId = res.data.id;
            this.edit_delete_historical_data.val1 = this.deleteHistoricalData.val;
            if (this.deleteHistoricalData.val){
              this.edit_delete_historical_data.val2 = this.deleteHistoricalData.time;
            }
            this.commitSon();
          }
        })
      }else if (this.type == "security_setting"){
        this.extSystematic.code = "security_setting";
        this.extSystematic.name = "安全设置";
        preservationAndQuerySystematic(this.extSystematic.parentId,this.extSystematic.code,this.extSystematic.name,this.extSystematic.val1,this.extSystematic.val2,
            this.extSystematic.icon1,this.extSystematic.icon).then(res => {
          console.log("保存系统父配置返回参数：", res);
          if (res.code == 0) {
            this.edit_forced_password_update_duration.parentId = res.data.id;
            this.commitSon();
          }
        })
      }
    },

    //保存子配置
    commitSon(){
      let extSystematicList = [];
      if (this.type == "system_vision") {
        extSystematicList.push(this.edit_platform_abbreviation);
        extSystematicList.push(this.edit_platform_full_name);
        extSystematicList.push(this.edit_PC_terminal_logo);
        extSystematicList.push(this.edit_mobile_terminal_logo);
      }else if (this.type == "historical_data"){
        extSystematicList.push(this.edit_delete_historical_data);
      }else if (this.type == "security_setting"){
        extSystematicList.push(this.edit_forced_password_update_duration);
      }
      console.log("请求参数：", extSystematicList);
      saveOrUpdateSystematic(extSystematicList).then(res => {
        console.log("保存系统子配置返回参数：", res);
        if (res.code == 0) {
          this.$message({
            message: res.message,
            type: 'success'
          });
          this.getSystemParamter();
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
        this.systemParamteDialogVisible = false;
      })
    },

    systemParamteDialogStyle(){
      let height = 300;
      if (this.type == "system_vision"){
        height = 450;
      }
      return `
            height: `+height+`px`;
    },
    openDialog() {
      this.dialogVisible = true
      this.form.pageCurrent = 1
      this.getDatabasesList()
    },
    getDatabasesList() {
      getDatabasesList(this.form.pageCurrent, this.form.pageSize).then(res => {
        if (res.code === 0) {
          this.tableData = res.data.records;
          this.form.pageCurrent = res.data.current;
          this.form.pageSize = res.data.size;
          this.dataTotal = res.data.total;
        }
      })
    },
    handleCurrentChange(val) {
      this.form.pageCurrent = val;
      this.form.pageSize = 10;
      this.getDatabasesList();
    },
    backUpDatabase() {
      this.isBacking = true;
      this.$message.info('备份生成中，稍后请前往备份历史和还原查看备份进度!')
      backUpDatabase().then(res => {
        this.isBacking = false;
        if (res) {
          /*downloadBlobFile(res, "系统操作日志");*/
        }
      });
    },
    restoringDatabase(url) {
      this.isRestoring = true;
      this.$message.info('还原数据库中')
      restoringDatabase(url).then(res => {
        this.isRestoring = false;
        if (res) {
          /*downloadBlobFile(res, "系统操作日志");*/
        }
      });
    }
  }
}

</script>

<style scoped>

</style>
